import { CommonState } from '@pec/aion-ui-core/slices/common';
import { ZuoraIFrameSignatureTypes } from '../interfaces';
import { Actions } from '../actions/zuora';

import { GET_ZUORA_SIGNATURE_REQUEST, GET_ZUORA_SIGNATURE_SUCCESS, GET_ZUORA_SIGNATURE_FAILURE } from 'constants/zuora';

export type State = CommonState & {
  zuoraIframeSignature: ZuoraIFrameSignatureTypes;
};

const initialState = {
  error: null,
  isFetching: false,
  zuoraIframeSignature: {}
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case GET_ZUORA_SIGNATURE_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GET_ZUORA_SIGNATURE_SUCCESS:
      return {
        isFetching: false,
        zuoraIframeSignature: {
          ...state.zuoraIframeSignature,
          [action.payload.type]: { ...action.payload.data }
        },
        error: null
      };
    case GET_ZUORA_SIGNATURE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
